// local imports
import request from "../base-request";

interface INotificationChannelSettingsResponse {
	data: {
		notification_channel_settings: {
			"asap-daily": {
				enabled_channels: ["email", "ms_teams"];
			};
		};
	};
}

export const updateNotificationChannelsSettings = async (
	notificationType: "asap-daily" | "digest" | "admin-digest",
	enabledChannels: string[]
) => {
	const [data] = await request<any>("/api/notifications/notification-channels/", {
		method: "PATCH",
		body: JSON.stringify({
			notificationType,
			update: { enabledChannels },
		}),
	});

	return data;
};

export const updateTemplateNotificationChannelsSettings = async (
	notificationType: "asap-daily" | "digest" | "admin-digest",
	enabledChannels: string[]
) => {
	const [data] = await request<any>("/api/notifications/template/notification-channels/", {
		method: "PATCH",
		body: JSON.stringify({
			notificationType,
			update: { enabledChannels },
		}),
	});

	return data;
};

export const fetchNotificationChannelsSettings = async () => {
	const [data] = await request<INotificationChannelSettingsResponse>(`/api/notifications/notification-channels/`);
	const response = { ...data.data.notification_channel_settings };

	return response;
};

export const fetchTemplateNotificationChannelsSettings = async () => {
	const [data] = await request<INotificationChannelSettingsResponse>(
		`/api/notifications/template/notification-channels/`
	);

	const response = { ...data.data.notification_channel_settings };

	return response;
};
